import { API } from "@swivl-mono/api-helper";
import { resolveCallScripts } from "@swivl-mono/helpers";
import type { ResolvedCallScript } from "@swivl-mono/types";
import { useEffect, useState } from "react";

import { SequencePageScope } from "../sequenceScope";

export interface UseScriptsInForceResult {
  /** The call scripts in force at the tab's scope — the same resolver the bot and the Call Scripts page use. */
  scripts: ResolvedCallScript[];
  loading: boolean;
}

/**
 * The call scripts a sequence day can start with (ENG-3403): every script in force at the scope,
 * resolved client-side from the org's rows exactly as the Call Scripts page resolves them. Loaded
 * once per scope by the view and shared through the context; the day rows and the day picker read it.
 */
export function useScriptsInForce(scope: SequencePageScope): UseScriptsInForceResult {
  const [scripts, setScripts] = useState<ResolvedCallScript[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    API.CallScript.listRows(scope.api.orgId)
      .then((rows) => {
        if (cancelled) return;
        setScripts(resolveCallScripts(rows, { groupId: scope.groupId, locationId: scope.locationId }));
      })
      .catch(() => {
        if (!cancelled) setScripts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [scope.api.orgId, scope.groupId, scope.locationId]);

  return { scripts, loading };
}
